import React, { useEffect , useState } from "react";

import NetworkPaginator  from "./Paginators/Network"
import LimitedSurveyModal from "./Modals/LimitedSurveyModal";

import User        from "~/services/user";
import PointsBoost from "~/services/pointsBoosters";

const List = ({type})=> {

  const [user        , setUser]      = useState({});
  const [isModalOpen , setModalOpen] = useState(false);
  const [modalItem   , setModalItem] = useState({});
  const [booster     , setBooster]   = useState(null);

  useEffect(()=> {
    (async()=> {
      setUser(await User.account());
      setBooster(await PointsBoost.getActiveBoost());
    }
    )();
  }, []);

  const checkLimitedNetwork = (item)=> {
    if((item.limitPoints <= user.totalPoints) && (item.usersPaymentLimit <= user.acceptedCashouts)) return;
    setModalOpen(true);
    setModalItem(item);
  };

  return (
      <div className="network-list">
        <LimitedSurveyModal
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
          item={modalItem}
          showPaymentsLimit={modalItem.usersPaymentLimit > user.acceptedCashouts}
          showPointsLimit={modalItem.limitPoints > user.totalPoints}
        />

        <NetworkPaginator type={type} user={user} checkLimitedNetwork={checkLimitedNetwork} booster={booster} />
      </div>
  );
};

export default List;
